export const environment = {
	production: true,
	ETUFOR_KEY:
		'neShViYq3t6n9z$C&F)H@McQfTjWnZr4u7x!A%D*G-KaNdRgUkXp2s5v8y/B?E(H+',
	backend: {
		userURL: 'https://de1lxozvo2.execute-api.us-west-2.amazonaws.com/prod',
		complaintsURL:
			'https://62ga4tqyy3.execute-api.us-west-2.amazonaws.com/prod',
		changelogURL:
			'https://sz28fs0zwa.execute-api.us-west-2.amazonaws.com/stage',
		supportURL: 'https://u3txz9hux6.execute-api.us-west-2.amazonaws.com/prod',
		checkinURL: 'https://s4cpjyzf0j.execute-api.us-west-2.amazonaws.com/prod',
		citiesURL: 'https://olu0e9yk5l.execute-api.us-west-2.amazonaws.com/prod',
	},
	ETUFOR_URL: 'https://etuforapinina.etufor.ce.gov.br/api/v1/',
	WHITE_LIST: ['team@ninamob.com', 'simony@ninamob.com'],
	GOOGLE_API_KEY: 'AIzaSyA7Qz7cIu9hWRZ1LhHMRO3NtYzn4P-LIoM',
	LOCATION_IQ_KEY: 'pk.5f0c37d787f21c88da451ec3543ed679',
	FACEBOOK_API_KEY: '910576992873785',
	AWS_ACCESS_KEY_ID: 'AKIA2ISI356SEQFTZEJL',
	AWS_SECRET_ACCESS_KEY: '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',

	AES_KEY: 'BABUINO_123',
};
